/*
 * Public API Surface of fingerprint-auth
 */

export { FingerprintService } from './lib/service/fingerprint.service';
export { FingerprintAuthModule } from './lib/fingerprint-auth.module';
export { BiometricActivatorModule } from './lib/biometric-activator/biometric-activator.module';
export { BiometricActivatorPageRoutingModule } from './lib/biometric-activator/biometric-activator-routing.module';
export { BiometricActivator } from './lib/biometric-activator/biometric-activator.page';
export { BiometricLoginActivePipe } from './lib/pipes/biometric-login.active.pipe';
export { FingerprintAuthConfiguration } from './lib/interfaces';